import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Icon } from "@atoms";

const Nav = ({
  currentSlide,
  totalSlides,
  showDots,
  showButtons,
  infinite,
  slideTo,
  slidePrev,
  slideNext,
}) => {
  return (
    <>
      {showDots && (
        <div className="absolute bottom-6 pos-center-x">
          {Array(totalSlides)
            .fill()
            .map((item, idx) => (
              <button
                key={idx}
                type="button"
                className={classNames({
                  "outline-none focus:outline-none h-3 w-3 rounded-full transition mx-1": true,
                  "bg-blue": idx === currentSlide,
                  "bg-white": idx !== currentSlide,
                })}
                onClick={() => slideTo(idx)}
              >
                <span className="hidden">{idx}</span>
              </button>
            ))}
        </div>
      )}

      {showButtons && (
        <>
          <button
            type="button"
            className={classNames({
              "outline-none focus:outline-none absolute bg-green-3 text-green-1 hover:text-white transition w-10 h-10 rounded-full flex items-center justify-center left-6 lg:left-20": true,
              "opacity-100 pointer-events-auto": currentSlide !== 0 || infinite,
              "opacity-25 pointer-events-none": currentSlide === 0 && !infinite,
            })}
            style={{
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
            onClick={() => slidePrev()}
          >
            <Icon
              name="Arrow"
              className="w-8 h-3"
              style={{ transform: "rotate(180deg)" }}
            />
          </button>
          <button
            type="button"
            className={classNames({
              "outline-none focus:outline-none absolute bg-green-3 text-green-1 hover:text-white transition w-10 h-10 rounded-full flex items-center justify-center right-6 lg:right-20": true,
              "opacity-100 pointer-events-auto":
                currentSlide < totalSlides - 1 || infinite,
              "opacity-25 pointer-events-none":
                currentSlide === totalSlides - 1 && !infinite,
            })}
            style={{
              top: "50%",
              transform: "translate(50%, -50%)",
            }}
            onClick={() => slideNext()}
          >
            <Icon name="Arrow" className="w-8 h-3" />
          </button>
        </>
      )}
    </>
  );
};

Nav.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  totalSlides: PropTypes.number.isRequired,
  showButtons: PropTypes.bool.isRequired,
  showDots: PropTypes.bool.isRequired,
  infinite: PropTypes.bool.isRequired,
  slideTo: PropTypes.func,
  slidePrev: PropTypes.func,
  slideNext: PropTypes.func,
};

Nav.defaultProps = {
  slideTo: null,
  slidePrev: null,
  slideNext: null,
};

export default Nav;
